import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import LoginForm from './LoginForm';
import ConfirmByPhoneForm from './ConfirmByPhoneForm';
import AuthLayout from '../AuthLayout';
import AccessRecovery from './AccessRecovery';

export default function () {
  return (
    <AuthLayout>
      <Routes>
        <Route path="/" element={<LoginForm confirmByPhoneUrl="./confirm-by-phone" accessRecoveryUrl="./access-recovery" />} />
        <Route path="/confirm-by-phone" element={<ConfirmByPhoneForm loginUrl="../" />} />
        <Route path="/access-recovery" element={<AccessRecovery loginUrl="../" />} />
        <Route path="/*" element={<Navigate to="./" replace/>} />
      </Routes>
    </AuthLayout>
  );
}
